module.exports = __webpack_public_path__ + "img/origins.75e47f10.jpg";